export const validatePassword = (password) => ({
    pwdLength: password.length >= 8,
    pwdCapital: /[A-Z]/.test(password),
    pwdNonCapital: /[a-z]/.test(password),
    pwdNumber: /\d/.test(password),
    pwdSpecial: /[~\-!@#$%^&*.]/.test(password),
});
export const isPasswordValid = (password) => Object.values(validatePassword(password)).every(Boolean);
